import { ShieldCheck, BadgeCheck, Award } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../motion/Reveal";

const BRANDS = ["Hikvision", "Dahua", "eSSL", "ZKTeco", "TP-Link Omada", "Matrix", "Honeywell", "Ubiquiti", "CP Plus"];

export const TrustBand = () => (
  <section className="bg-nx-navy border-b border-white/10 py-20 sm:py-28" data-testid="trust-section">
    <div className="nx-wrap">
      <Reveal>
        <div className="flex items-center gap-4 mb-6">
          <span className="h-px w-12 bg-nx-gold/70" />
          <span className="text-[10px] sm:text-xs tracking-[0.16em] sm:tracking-[0.24em] uppercase text-nx-goldlight">Trust & Credentials</span>
        </div>
        <h2 className="font-marcellus text-3xl sm:text-4xl lg:text-5xl text-white leading-tight max-w-3xl" data-testid="trust-heading">
          Trusted By Businesses Across Kerala
        </h2>
        <p className="mt-5 flex items-center gap-2.5 text-sm text-nx-goldlight tracking-wide" data-testid="trust-certified">
          <Award size={16} className="shrink-0" /> Certified Security Systems Integrator
        </p>
      </Reveal>

      <Stagger className="mt-12 grid sm:grid-cols-3 gap-px bg-white/10 border border-white/10">
        <StaggerItem>
          <div className="h-full bg-nx-navy p-7 flex items-start gap-4" data-testid="trust-badge-integrator">
            <ShieldCheck size={22} className="text-nx-goldlight shrink-0 mt-0.5" strokeWidth={1.5} />
            <div>
              <p className="text-sm text-white font-medium">Authorized System Integrator</p>
              <p className="text-xs text-slate-500 mt-1.5 leading-relaxed">Authorized partner for leading security & infrastructure brands</p>
            </div>
          </div>
        </StaggerItem>
        <StaggerItem>
          <div className="h-full bg-nx-navy p-7 flex items-start gap-4" data-testid="trust-badge-hikvision">
            <BadgeCheck size={22} className="text-nx-goldlight shrink-0 mt-0.5" strokeWidth={1.5} />
            <div>
              <p className="text-sm text-white font-medium">Hikvision Authorized Partner</p>
              <p className="text-xs text-slate-500 mt-1.5 leading-relaxed">Genuine products, authorised channel, full warranty support</p>
            </div>
          </div>
        </StaggerItem>
      </Stagger>

      <Reveal delay={0.15}>
        <p className="mt-14 mb-6 text-[10px] tracking-[0.28em] uppercase text-slate-500">Brand Partnerships</p>
      </Reveal>
      <Stagger className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-9 gap-px bg-white/10 border border-white/10">
        {BRANDS.map((b) => (
          <StaggerItem key={b}>
            <div className="flex items-center justify-center h-20 bg-nx-navy2 hover:bg-nx-navy transition-colors px-3" data-testid={`trust-brand-${b.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <span className="font-marcellus text-sm sm:text-base text-slate-300 tracking-wide text-center">{b}</span>
            </div>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
  </section>
);
